import { Card, CardBody } from '../../../../components/card/card';
import CardHeader from 'react-bootstrap/esm/CardHeader';
import Breadcrumb from '../../../../components/Shared/Breadcrumb';
import { Link } from 'react-router-dom';
import ResultList from './ResultList/ResultList';
import { useTranslation } from 'react-i18next';
import SummaryList from './Summary/SummaryList';
import AttendanceCharts from './AttendanceCharts/AttendanceCharts';
import { useState } from 'react';

const AttendanceAnalysis = () => {
  const { t } = useTranslation();

  // حالة لتتبع التبويب النشط
  const [activeTab, setActiveTab] = useState('details'); // القيم: 'details'، 'summary'، 'indicators'

  const BcrumbList = [
    {
      name: 'Home',
     link: '/RAQ/HomePage',
    },
    {
      name: t('AttendanceAnalysis'),
      link: null,
    },
  ];

  return (
    <>
      <div className="row">
        <Breadcrumb BreadcrumbList={BcrumbList} PageName="AttendanceAnalysis" />

        <Card className="mb-3 fw-bold bg-theme bg-opacity-25 d-flex justify-content-between align-items-center">
          <CardHeader className="px-3 py-0 ">
            <ul className="nav nav-pills card-header-pills d-flex m-0 p-0 w-100">
              <li className="nav-item flex-fill m-1">
                <Link
                  className={`nav-link text-center border ${
                    activeTab === 'details' ? 'active' : ''
                  }`}
                  onClick={() => setActiveTab('details')} // تغيير التبويب النشط
                  to="#">
                  <i className="bi bi-journal-text me-2"></i>
                  {t('AttendanceDetails')}
                </Link>
              </li>
              <li className="nav-item flex-fill m-1">
                <Link
                  className={`nav-link text-center border ${
                    activeTab === 'summary' ? 'active' : ''
                  }`}
                  onClick={() => setActiveTab('summary')}
                  to="#">
                  <i className="bi bi-bar-chart-line me-2"></i>
                  {t('AttendanceSummary')}
                </Link>
              </li>
              <li className="nav-item flex-fill m-1">
                <Link
                  className={`nav-link text-center border ${
                    activeTab === 'indicators' ? 'active' : ''
                  }`}
                  onClick={() => setActiveTab('indicators')}
                  to="#">
                  <i className="fa fa-tachometer-alt me-2"></i>
                  {t('AttendanceIndicators')}
                </Link>
              </li>
            </ul>
          </CardHeader>
        </Card>
        <Card>
          <CardBody className="p-4">
            {activeTab === 'details' && <ResultList />}
            {activeTab === 'summary' && <SummaryList />}
            {activeTab === 'indicators' && <AttendanceCharts />}
          </CardBody>
        </Card>
      </div>
    </>
  );
};

export default AttendanceAnalysis;

// {['ABSENT', 'LATE', 'EARLY', 'ExtraHours']?.map((type, index) => (
//   <div key={index} className="col-xl-6 mx-auto mb-4">
//     <Card>
//       <CardHeader className="bg-theme bg-opacity-20">
//         <div className="text-center fs-5 fw-bold ">{t(type)}</div>
//       </CardHeader>

//       {data?.length > 0 && (
//         <>
//           {type === 'ABSENT' && (
//             <PIECHART
//               AbsenceData={data
//                 ?.slice()
//                 ?.filter((f) => f.nonFingerprinted !== 0)
//                 ?.map((m) => m.nonFingerprinted)}
//               labels={data
//                 ?.slice()
//                 ?.filter((f) => f.nonFingerprinted !== 0)
//                 ?.map((m) => m.organizationName)}
//             />
//           )}

//           {type === 'LATE' && (
//             <DOUGHNUTCHART
//               LateData={data
//                 ?.slice()
//                 ?.filter((f) => f.delay !== 0)
//                 ?.map((m) => m.delay)}
//               labels={data
//                 ?.slice()
//                 ?.filter((f) => f.delay !== 0)
//                 ?.map((m) => m.organizationName)}
//             />
//           )}

//           {type === 'ExtraHours' && (
//             <POLARCHART
//               overTimeData={data
//                 ?.slice()
//                 ?.filter((f) => f.overTime !== 0)
//                 ?.map((m) => m.overTime)}
//               labels={data
//                 ?.slice()
//                 ?.filter((f) => f.overTime !== 0)
//                 ?.map((m) => m.organizationName)}
//             />
//           )}

//           {type === 'EARLY' && (
//             <DOUGHNUTCHART2
//               EARLYData={data
//                 ?.slice()
//                 ?.filter((f) => f.early !== 0)
//                 ?.map((m) => m.early)}
//               labels={data
//                 ?.slice()
//                 ?.filter((f) => f.early !== 0)
//                 ?.map((m) => m.organizationName)}
//             />
//           )}
//         </>
//       )}
//     </Card>
//   </div>
// ))}
